// Number of SPPR periods to show on the productivity page
export const NUM_SPPR_PERIODS = 15;
export const CHART_SPPR_PERIODS = 14;

// Max number of hours to display hourly productivity data for
export const PRODUCTIVITY_HOURS_LOOKBACK = 24;
